import styles from './Footer.module.css'

function Footer(){
    return(
        <footer className={styles.footer}>
            Developed by Murilo Bezerra &reg; 2024
        </footer>
    );
}

export default Footer;